export const postalCodeRegex = /^\d{5}$/;